export default {
  publisherdeskLib: 'https://cdn.tpdads.com/configs/pricespy.js',
  doubleclickLib: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
  loadGDPRScript: false,
};
